import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Button, Typography } from '@one-thd/sui-atomic-components';

const { string } = PropTypes;

const DeliveryZipcodeWithLabel = ({ className }) => {
  const { deliveryZip, isConsumerApp } = useContext(ExperienceContext);

  const handleZipcodeClick = () => {
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('open_delivery_zip_menu');
    }
  };

  if (isConsumerApp) {
    return null;
  }

  return (
    <div
      className={classNames('sui-flex sui-items-center', className)}
      data-testid="delivery-zipcode-label"
    >
      <Typography variant="body-base" component="span">for Delivery to</Typography>&nbsp;
      <Button
        variant="secondary"
        size="small"
        className="sui-flex sui-items-center sui-gap-2 group-hover/zipcode:sui-text-brand"
        onClick={handleZipcodeClick}
      >
        <Typography variant="body-base" component="span">
          <span className="sui-underline">
            {deliveryZip || '...'}
          </span>
        </Typography>
      </Button>
    </div>
  );
};

DeliveryZipcodeWithLabel.propTypes = {
  className: string
};

DeliveryZipcodeWithLabel.defaultProps = {
  className: ''
};

export { DeliveryZipcodeWithLabel };